var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.28 67.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 18.44,
    width: 27,
    height: 31
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37 63.44 1 33.46 37 3.48 37 63.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.21,67.88l-1.42-1.41a46.05,46.05,0,0,0,0-65.06L67.21,0A48.06,48.06,0,0,1,67.21,67.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.5,67.18A47,47,0,0,0,66.5.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.21,60.88l-1.42-1.41a35.26,35.26,0,0,0,0-49.82l1.42-1.42A37.28,37.28,0,0,1,57.21,60.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.5,60.18a36.21,36.21,0,0,0,0-51.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,52.65l-1.42-1.42a24.65,24.65,0,0,0,0-34.82L47.21,15A26.65,26.65,0,0,1,47.21,52.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.5,51.94a25.61,25.61,0,0,0,0-36.23"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/sound_on.1ed44821d83622e045ef6869d3f05eb0.svg";
export { ForwardRef as ReactComponent };